import { getLocalApi } from "./localApi";
import { BoardBasis} from "app/shared/model";
import apiConfig from "app/api/apiConfig.json";

export async function getAllBoardBasis() : Promise<BoardBasis[]> {
    const localApi = await getLocalApi();

    return await localApi.fetchList(apiConfig.reference_data_get_board_basis, (dto:any) => ({
        name: dto.name,
        id: dto.id
    }), 'Unable to fetch Board Basis')
}